import { CSSTransition } from 'react-transition-group';
import ButtonIconGhostSmall from '../../../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import LeftMenuDesign from '../../../../components/common/LeftMenuDesign/LeftMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import './LeftCabinetDesignMenu.scss';
import DropdownFilter from '../../../../components/common/DropdownFilter/DropdownFilter';
import ButtonIconOutlineMedium from '../../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import SearchComponent from '../../../../components/common/SearchComponent/SearchComponent';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import { useCallback, useEffect, useState } from 'react';
import CardProduct from '../../../../components/card/CardProduct/CardProduct';
import Tag from '../../../../components/common/Tag/Tag';
import ListTypeModule from '../../../../components/common/ListTypeModule/ListTypeModule';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../../../../store/actions/product.action';
import { fetchModules } from '../../../../store/actions/module.action';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Divider, Spin } from 'antd';
import { Empty } from 'antd';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import TabComponent from '../../../../components/common/TabComponent/TabComponent';
import InfiniteScroll from '../../../../components/common/InfiniteScroll/InfiniteScroll';

const LeftCabinetDesignMenu = ({ open, onClose, moduleType, title }) => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';

  const [openSearch, setOpenSearch] = useState(false);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { products } = useSelector(state => state.product);
  const { modules } = useSelector(state => state.module);

  const [listTypeProduct, setListTypeProduct] = useState([]);
  const [offset, setOffset] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();
  const productType = searchParams.get('product_type');
  const subType = searchParams.get('sub_type');

  const updateFilter = (key, value) => {
    const newParams = new URLSearchParams(searchParams);

    if (value) {
      newParams.set(key, value);
    } else {
      newParams.delete(key);
    }

    setSearchParams(newParams);
  };

  const loadMoreData = useCallback(() => {
    if (productType && open && !modules.isLoading) {
      dispatch(fetchModules({ productType, offset, limit: 10 })).then(
        action => {
          if (action.payload.data?.length) {
            setOffset(prev => prev + 10);
          }
        }
      );
    }
  }, [offset, productType, open, modules.isLoading]);

  useEffect(() => {
    const product = products.data?.find(item =>
      item.types.some(type => type.code?.includes(subType))
    );
    if (product) {
      const listTypeProduct = product.types
        ?.filter(item => item.code !== 'kitchen_island_lower')
        .map(item => ({
          key: item.id,
          label: item.name,
        }));
      if (listTypeProduct.length) {
        setListTypeProduct([...listTypeProduct]);
        updateFilter('product_type', listTypeProduct[0].key);
      }
    }
    // if (product) {
    //   dispatch(fetchModules({ product_type: product.id }));
    //   // dispatch(fetchModules({}));
    // }
  }, [subType, products]);

  useEffect(() => {
    if (productType && open) {
      setOffset(prev => {
        return 0;
      });
    }

    // Lấy tất cả module
    // dispatch(fetchModules({}));
  }, [productType, open]);

  useEffect(() => {
    if (offset === 0 && productType && open) {
      loadMoreData();
    }
  }, [offset, productType, open]);

  return (
    <LeftMenuDesign
      open={open}
      classNames={{
        root: '!left-[60px] relative',
        content: '!p-0 gap-0',
        body: '!overflow-hidden',
      }}
      styles={{ content: { background: '#F7F7F7' } }}
      header={
        <>
          <span className="text-title-large text-nowrap">{title}</span>
          <ButtonIconGhostSmall icon={<Icon.ICClose />} onClick={onClose} />
        </>
      }
      content={
        <>
          {moduleType === 'tv' && (
            <div className="flex pt-8 px-16 items-start self-stretch bg-fills-white">
              <TabComponent
                items={[
                  { label: t('TV cabinet'), key: 'tv' },
                  { label: t('Decorative Cabinet'), key: 'decorative' },
                ]}
                activeKey={subType}
                onTabClick={key => {
                  setSearchParams(prev => {
                    const params = Object.fromEntries([...prev]);
                    params['sub_type'] = key;
                    return { ...params };
                  });
                }}
              />
            </div>
          )}
          {moduleType === 'decorative' && (
            <div className="flex pt-8 px-16 items-start self-stretch bg-fills-white">
              <TabComponent
                items={[
                  { label: t('Decorative Cabinet'), key: 'decorative' },
                  { label: t('TV cabinet'), key: 'tv' },
                ]}
                activeKey={subType}
                onTabClick={key => {
                  setSearchParams(prev => {
                    const params = Object.fromEntries([...prev]);
                    params['sub_type'] = key;
                    return { ...params };
                  });
                }}
              />
            </div>
          )}
          <Divider className="!p-0 !m-0" type="horizontal" />
          <div className="left-cabinet-design-menu-header-actions bg-fills-white">
            <div className="flex self-stretch">
              <div className={'flex items-start gap-8 grow'}>
                <DropdownFilter
                  trigger={['click']}
                  menu={{
                    items: [
                      ...listTypeProduct.map(item => ({
                        ...item,
                        label: (
                          <div
                            className="flex px-12 py-8 justify-between items-center"
                            onClick={() =>
                              updateFilter('product_type', item.key)
                            }
                          >
                            <span className="text-body-medium">
                              {getValueFromString(item.label)}
                            </span>
                            {productType === item.key && (
                              <span className="w-20 h-20 flex">
                                <Icon.ICCheck />
                              </span>
                            )}
                          </div>
                        ),
                      })),
                    ],
                  }}
                  size="default"
                  className={'flex-row-reverse grow'}
                  value={getValueFromString(
                    listTypeProduct.find(item => item.key == productType)
                      ?.label ?? t('Please select')
                  )}
                />
                <ButtonIconOutlineMedium
                  icon={<Icon.ICSearch />}
                  onClick={() => {
                    // setOpenSearch((prev) => !prev);
                  }}
                />
              </div>
            </div>
            {/* <ListTypeModule /> */}
            {/* </div> */}
          </div>
          <div
            id="modules-scroll-infinitie"
            className="flex self-stretch grow overflow-auto"
          >
            <InfiniteScroll
              className="grid grid-cols-2 p-8 justify-start items-start gap-2 self-stretch"
              dataLength={modules.data?.length ?? 0}
              next={loadMoreData}
              hasMore={modules.data.length < modules.total}
              isLoading={modules.isLoading}
              scrollableTarget={'modules-scroll-infinitie'}
            >
              {modules.data?.map(item => {
                let name = getValueFromString(item.name);
                let description = getValueFromString(item.description ?? '');

                return (
                  <CardProduct
                    key={item.id}
                    md={item}
                    title={name}
                    description1={description}
                    description2={item.size}
                    moduleType={item.moduleType}
                  />
                );
              })}
            </InfiniteScroll>
          </div>
        </>
      }
    />
  );
};

export default LeftCabinetDesignMenu;
